
















import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { closeBarCodeView } from "@/store/user/mutation-types";

const UserModule = namespace("user");
@Component
export default class WechatBarcode extends Vue {
  @Prop() private path!: string;
  @Prop() private showText!: boolean;
  @UserModule.Mutation(closeBarCodeView) closeBarCodeView: any;
}
